// // Import the functions you need from the SDKs you need
// import { initializeApp } from "firebase/app";
// // TODO: Add SDKs for Firebase products that you want to use
// // https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCGIdW4viLkGtWVma9EjD43vmLbZd6_dE4",
  authDomain: "online-resele-market.firebaseapp.com",
  projectId: "online-resele-market",
  storageBucket: "online-resele-market.appspot.com",
  messagingSenderId: "792277081437",
  appId: "1:792277081437:web:7f20bfbc92d583331a5cb4",
};

export default firebaseConfig;

// // Initialize Firebase
// const app = initializeApp(firebaseConfig);
// export default app;
